import { CalendarDays } from '@tamagui/lucide-icons';
import { Pressable } from '@unistocks/components/basic/pressable';
import { Column, Row } from '@unistocks/components/layout/flex';
import { Heading } from '@unistocks/components/text/text';
import { CalendarEventsList } from '@unistocks/features/dashboard/components/dashboard-data/date/components/calendar-events-list';
import { CalendarLayout } from '@unistocks/features/dashboard/components/dashboard-data/date/layout';
import {
  DashboardItemFrame,
  DashboardItemProps
} from '@unistocks/features/dashboard/components/dashboard-item/dashboard-item';
import { DashboardItemHeader } from '@unistocks/features/dashboard/components/dashboard-item/dashboard-item-header';
import { formatDate, t } from '@unistocks/localization';
import { triggerHaptics } from '@unistocks/shared/utils/haptics/haptics';
import { today as getToday } from '@unistocks/shared/utils/util';
import { useMedia } from 'tamagui';

export const Calendar: React.FC<DashboardItemProps> = ({ item, openSettings, ...frameProps }) => {
  const media = useMedia();
  const today = getToday();
  const layout = item.settings.layout ?? CalendarLayout.Date;

  const onLongPress = () => {
    triggerHaptics('longPress');
    openSettings(item);
  };

  if (layout === CalendarLayout.Events) {
    const title = item.settings.title?.trim() || t('::CalendarEvents:UpcomingEvents');

    return (
      <DashboardItemFrame {...frameProps}>
        <DashboardItemHeader item={item} title={title} openSettings={openSettings} />
        <CalendarEventsList item={item} />
      </DashboardItemFrame>
    );
  }

  return (
    <DashboardItemFrame {...frameProps}>
      <Row justifyContent={'center'} alignItems={'center'} my={'auto'} gap={'$3'}>
        <Pressable withScale onLongPress={onLongPress}>
          <CalendarDays size={media.sm ? '$7' : '$8'} color={'$headingFont'} />
        </Pressable>
        <Column alignItems="center">
          <Heading size={'$9'} userSelect="none" className="drag-handle" $sm={{ size: '$8' }}>
            {formatDate(today, { month: 'long', day: 'numeric' })}
          </Heading>
          <Heading size={'$8'} userSelect="none" $sm={{ size: '$7', fw: '$5' }}>
            {formatDate(today, { year: 'numeric' })} | {t('::Week')} {today.weekNumber}
          </Heading>
        </Column>
      </Row>
    </DashboardItemFrame>
  );
};
